export const FETCH_CONTENT_RECOMENDATIONS_INIT = 'FETCH_CONTENT_RECOMENDATIONS_INIT';
export const FETCH_CONTENT_RECOMENDATIONS_SUCCESS = 'FETCH_CONTENT_RECOMENDATIONS_SUCCESS';
export const FETCH_CONTENT_RECOMENDATIONS_ERROR = 'FETCH_CONTENT_RECOMENDATIONS_ERROR';
export const CLEAR_RECOMENDATIONS = 'CLEAR_RECOMENDATIONS';
